import React from 'react'

const ChartIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <g fill="#4080FC" clipPath="url(#a)">
        <path d="M.719 17.99c.404 0 .718-.342.718-.749V.741A.732.732 0 0 0 .72 0C.323 0 0 .342 0 .74v16.501c0 .407.323.75.719.75ZM3.726 17.814h7.015c.494 0 .8-.333.8-.86V15.13c0-.537-.306-.87-.8-.87H3.726c-.512 0-.808.333-.808.87v1.823c0 .527.296.86.808.86ZM3.726 13.114H14.82c.503 0 .8-.324.8-.86V10.43c0-.537-.297-.86-.8-.86H3.726c-.512 0-.808.323-.808.86v1.823c0 .537.296.86.808.86ZM3.726 8.422h13.15c.494 0 .79-.333.79-.87V5.729c0-.528-.296-.86-.79-.86H3.726c-.512 0-.808.332-.808.86v1.823c0 .537.296.87.808.87ZM3.726 3.72h9.027c.485 0 .79-.333.79-.86V1.027c0-.527-.305-.851-.79-.851H3.726c-.512 0-.808.324-.808.851V2.86c0 .527.296.86.808.86Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChartIcon
